export const openidAccessToken: BGOOpenidAccessToken = {
  access_token:
    '0691f4b6f8794b90be99e134b1fbd5d5a88rc7723n7fva6qzae8js0tfltnk7j4',
  me_profile: {
    nickname: '休假中的地瓜',
    photo: '',
    chat_id: 'fc4d9f387e992e066fde5e255bbf79e725374f6b',
  },
  access_token_expired_at: 1629439305691,
};

export const profile = {
  country: 'TW',
  app_version: '2.2.5',
  level: 10,
  phoneVerified: false,
  photo_encode: '',
  countrycode: 'TW',
  os_version: '10',
  photo: '',
  language: 'zh_TW',
  platform: 'Android',
  chat_id: '913504d093311f611c9e2421c982bb3d9719c313',
  phone_model: 'K20 Pro',
  emailVerified: false,
  nickname: '休假中的地瓜君',
  lang: 'zh_TW',
};

export const openId = '2102816647982104576';

export const trackingSessionData = {
  app_build: '220502',
  device_id: '0592e38a-e9bf-4fc6-ac77-e3452f8183a2',
  device_model: 'mi',
  action_index: 0,
  session_id: 'd30a2d3e-6eca-480b-86d7-efb74599fa2b',
  previous_session_id: '66306d5a-7ec2-4db1-b0d9-923a5ecd5029',
  session_index: 86,
  network_type: 'wifi',
};

export default { openidAccessToken, profile, openId, trackingSessionData };
